module.exports = __webpack_public_path__ + "img/logo_ct.42b69d6b.png";